export const PricingTable = ({ tiers, note, ctaLabel, ctaHref }) => (
  <div className="pricing-wrap">
    <div className="pricing-grid">
      {tiers.map((tier, i) => (
        <div className={"pricing-card" + (i === 1 ? " featured" : "")} key={i}>
          <h3>{tier.title}</h3>
          <div className="pricing-price">{tier.price}</div>
          <p>{tier.desc}</p>
        </div>
      ))}
    </div>
    {note && <p className="pricing-note">{note}</p>}
    {ctaHref && (
      <div className="pricing-cta-wrap">
        <a className="btn btn-primary" href={ctaHref} target="_blank" rel="noreferrer">
          {ctaLabel}
        </a>
      </div>
    )}
  </div>
);
